import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Crosshair, Settings, Shield, Clock, Zap } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: Flame,
    text: 'El error invisible que te está haciendo perder partidas'
  }, {
    icon: Settings,
    text: 'Configuración PRO (sensibilidad, HUD, gráficos y audio)'
  }, {
    icon: Crosshair,
    text: 'Cómo posicionarte para forzar errores del rival'
  }, {
    icon: Zap,
    text: 'Cuándo atacar y cuándo esperar'
  }, {
    icon: Shield,
    text: 'Cómo sobrevivir más y cerrar partidas'
  }, {
    icon: Clock,
    text: 'Rutina de mejora diaria durante 7 días'
  }];
  return <section className="py-20 px-4 bg-gamer-dark relative" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-orbitron font-bold text-center text-white mb-16" data-id="element-3">
          Lo que vas a <span className="text-gamer-red" data-id="element-4">aprender</span>
        </motion.h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gamer-card p-6 rounded-lg border border-white/5 hover:border-gamer-red/50 transition-colors group" data-id="element-6">
              <div className="flex items-start gap-4" data-id="element-7">
                <div className="p-3 bg-gamer-red/10 rounded-lg group-hover:bg-gamer-red/20 transition-colors" data-id="element-8">
                  <benefit.icon className="w-6 h-6 text-gamer-red" data-id="element-9" />
                </div>
                <p className="text-gray-200 font-inter font-medium leading-relaxed" data-id="element-10">
                  {benefit.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}